import { DRAFT_TO_DOC_TYPE_WITH_LISTS } from 'wix-rich-content-common';

const getFontSizeNumber = (fontSize) => {
  const pxRegex = new RegExp("[0-9]+[px]");
  return pxRegex.exec(fontSize) ? fontSize.split("p")[0] : "";
};
const hasStyleChanges = (currentHeading, inlineStyles, documentStyle) => {
  const headerStyle = (documentStyle == null ? void 0 : documentStyle[DRAFT_TO_DOC_TYPE_WITH_LISTS[currentHeading]]) || {};
  return Object.entries(inlineStyles).some(([key, value]) => headerStyle[key] !== value);
};
const findOsName = () => {
  if (navigator.userAgent.indexOf("Win") !== -1)
    return "Windows";
  if (navigator.userAgent.indexOf("Mac") !== -1)
    return "MacOS";
  return null;
};

export { findOsName, getFontSizeNumber, hasStyleChanges };
//# sourceMappingURL=utils.js.map
